import { __assign, __rest } from "tslib";
import React from 'react';
import { Url } from '@wix/da-url';
import { ResourceType } from '../../types/resource';
import BiLink from '../../biLogger/Components/BiLink';
import { BiEventType } from '../../biLogger/constants';
export var CommentLink = function (_a) {
    var _b;
    var comment = _a.comment, children = _a.children, restProps = __rest(_a, ["comment", "children"]);
    return (React.createElement(BiLink, __assign({ href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), biData: {
            evid: BiEventType.ITEM_CLICK,
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId,
            creatorid: (_b = comment.user) === null || _b === void 0 ? void 0 : _b.useridUuid,
        } }, restProps), children));
};
CommentLink.displayName = 'CommentLink';
export default CommentLink;
//# sourceMappingURL=CommentLink.js.map